import { createSelector } from 'reselect';
import { uiSelector } from 'reducers/ui/selectors';

export const allProjectsUiSelector = createSelector(uiSelector, (ui) =>
  ui.get('allProjects')
);
